import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Card, CardBody, Col, Collapse, Row } from "reactstrap"
import moment from "moment"

const ContainerCollapse = ({ containerInfo }) => {
  const [collapse, setCollapse] = useState(false)

  return (
    <>
      <a className="font-weight-light" onClick={() => setCollapse(!collapse)}>
        {collapse ? "Hide container information" : "Show container information"}
        {collapse ? (
          <i className="mdi mdi-chevron-up ms-1"></i>
        ) : (
          <i className="mdi mdi-chevron-down ms-1"></i>
        )}
      </a>
      <Collapse isOpen={collapse}>
        <Card>
          <CardBody>
            <div className="d-flex flex-wrap mt-2 mb-3">
              <h4 className="font-size-16">Container Information</h4>
              <button
                type="button"
                onClick={() => {
                  setCollapse(false)
                }}
                className="close mt-2"
              ></button>
            </div>
            <section id="container-info-section">
              <Row>
                <Col xs="12" sm="6">
                  <div className="mb-3">
                    <p className="font-size-14 mb-0">Container</p>
                    <h4 className="font-size-16">
                      {containerInfo.ContainerName || "-"}
                    </h4>
                  </div>
                </Col>
                <Col xs="12" sm="6">
                  <div className="mb-3">
                    <p className="font-size-14 mb-0">CI</p>
                    <h4 className="font-size-16">{containerInfo.CI || "-"}</h4>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="6">
                  <div className="mb-3">
                    <p className="font-size-14 mb-0">Agent Name</p>
                    <h4 className="font-size-16">
                      {containerInfo.AgentName || "-"}
                    </h4>
                  </div>
                </Col>
                <Col xs="12" sm="6">
                  <div className="mb-3">
                    <p className="font-size-14 mb-0">Size/Type</p>
                    <h4 className="font-size-16">
                      {containerInfo.SizeType || "-"}
                    </h4>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="6">
                  <div className="mb-3">
                    <p className="font-size-14 mb-0">Date In</p>
                    <h4 className="font-size-16">
                      {containerInfo.DateIn
                        ? moment(containerInfo.DateIn).format("DD-MM-YYYY")
                        : "-"}
                    </h4>
                  </div>
                </Col>
                <Col xs="12" sm="6">
                  <div className="mb-3">
                    <p className="font-size-14 mb-0">Time In</p>
                    <h4 className="font-size-16">
                      {containerInfo.DateInTime || "-"}
                    </h4>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="6">
                  <div className="mb-3">
                    <p className="font-size-14 mb-0">Date Out</p>
                    <h4 className="font-size-16">
                      {containerInfo.DateOut
                        ? moment(containerInfo.DateOut).format("DD-MM-YYYY")
                        : "-"}
                    </h4>
                  </div>
                </Col>
                <Col xs="12" sm="6">
                  <div className="mb-3">
                    <p className="font-size-14 mb-0">Time Out</p>
                    <h4 className="font-size-16">
                      {containerInfo.DateOutTime || "-"}
                    </h4>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="6">
                  <div className="mb-3">
                    <p className="font-size-14 mb-0">AV Date</p>
                    <h4 className="font-size-16">
                      {containerInfo.AVDate
                        ? moment(containerInfo.AVDate).format("DD-MM-YYYY")
                        : "-"}
                    </h4>
                  </div>
                </Col>
                <Col xs="12" sm="6">
                  <div className="mb-3">
                    <p className="font-size-14 mb-0">AV Time</p>
                    <h4 className="font-size-16">
                      {containerInfo.AVTime || "-"}
                    </h4>
                  </div>
                </Col>
              </Row>
            </section>
          </CardBody>
        </Card>
      </Collapse>
    </>
  )
}

ContainerCollapse.propTypes = {
  containerInfo: PropTypes.object,
}
export default ContainerCollapse
